import { render, staticRenderFns } from "./SeatBreakdown.vue?vue&type=template&id=620135d8&"
import script from "./SeatBreakdown.vue?vue&type=script&lang=js&"
export * from "./SeatBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports